class GTMDataLayer extends window.BAO.CustomElement() {
	constructor() {
		super();
		window.dataLayer = window.dataLayer || [];
	}

	setupListeners() {
		super.setupListeners();

		const navLinks = document.querySelectorAll(
			'[data-gtm-nav-link]'
		);

		navLinks.forEach(el => {
			el.addEventListener('click', this.handleNavClick.bind(this));
		});
	}

	handleNavClick(event) {
		event.stopImmediatePropagation();

		const target = event.currentTarget;
		const eventName = target.closest('[data-gtm-event-name]');
		const targetContext = target.closest('[data-gtm-target-context]');
		const targetElement = target.closest('[data-gtm-target-element]');

		window.dataLayer.push({
			event: eventName?.dataset.gtmEventName || 'nav_link_click',
			target_text: target.dataset.gtmTargetText || target.innerText,
			target_context: targetContext?.dataset.gtmTargetContext,
			target_element: targetElement?.dataset.gtmTargetElement || 'link',
		});
	}
}

if (!customElements.get('gtm-datalayer')) {
	customElements.define('gtm-datalayer', GTMDataLayer);
}
